import { Injectable } from '@angular/core';

import { colorToHex, LightColor } from '@shure/shared/angular/data-access/system-api/models';

import { colorToFilter, CssFilter } from '../models/color-converter-utils';

@Injectable({ providedIn: 'root' })
export class ColorConverterService {
	public getHexCode(color: LightColor): string {
		return colorToHex[color] || colorToHex[LightColor.Green];
	}

	public getColorFilter(color: LightColor | undefined): string {
		if (color === undefined) {
			return '';
		}

		const filterValues = colorToFilter[color] || colorToFilter[LightColor.Green];
		return this.createFilterString(filterValues);
	}

	private createFilterString(filter: CssFilter): string {
		return (
			`invert(${filter.invert}%) sepia(${filter.sepia}%) saturate(${filter.saturate}%) ` +
			`hue-rotate(${filter.hueRotate}deg) brightness(${filter.brightness}%) contrast(${filter.contrast}%)`
		);
	}
}
